import { render } from "./MobileLayout.vue?vue&type=template&id=7631dc92&scoped=true"
import script from "./MobileLayout.vue?vue&type=script&lang=js"
export * from "./MobileLayout.vue?vue&type=script&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=7631dc92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7631dc92"]])

export default __exports__